/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import React, { useState } from "react";
import PropTypes from "prop-types";
import SafeImage from "../../SafeImage";
import { userDisplayText } from "../../../utils/userUtils";
import moment from "moment";
import _ from "lodash";

import RuleStatusToggle from "../../shared/RuleStatusToggle";
import StatusToggle from "js/components/shared/StatusToggle";
import { ChakraFAIcon } from "@/components/ui/Icon";
import { useClasswizeConfigStore } from "@/stores/classwizeConfigStore";

const ContentPolicy = (props) => {
	const classwizeConfig = useClasswizeConfigStore.getState().data;

	const blockedRulesOnlyToggleItems = [
		{ label: "On", color: "red" },
		{ label: "Off", color: "grey" },
	];
	const [blockedOnlySelectedItem, setBlockedOnlySelectedItem] = useState(
		_.defaultTo(props.policy.enabled, false) ? blockedRulesOnlyToggleItems[0] : blockedRulesOnlyToggleItems[1]
	);

	const changeBlockedOnlyToggle = (item) => {
		setBlockedOnlySelectedItem(item);

		if (item.label === "On") {
			props.handleChangeType("blocked", props.policy);
		} else {
			props.handleChangeType("off", props.policy);
		}
	};

	const renderStatus = () => {
		if (props.policy.permanent === true) {
			if (props.policy.override > new Date().getTime() / 1000) {
				return <div>Unblock overridden until {moment.unix(props.policy.override).format("LT")}</div>;
			}

			if (classwizeConfig.create_blocking_rules_only) {
				return (
					<StatusToggle selectedItem={blockedOnlySelectedItem} items={blockedRulesOnlyToggleItems} onChange={changeBlockedOnlyToggle} />
				);
			} else {
				return <RuleStatusToggle type={props.policy.type} onChange={(type) => props.handleChangeType(type, props.policy)} />;
			}
		}

		if (props.policy.lifetime > 0) {
			if (props.policy.override > new Date().getTime() / 1000) {
				return <div>Unblock overridden until {moment.unix(props.policy.override).format("LT")}</div>;
			}

			const fromNow = moment.unix(props.policy.lifetime).fromNow(true);

			return <div> Unblocked for {fromNow}</div>;
		}
	};

	const getUser = () => {
		if (props.policy.user) {
			const user = props.users.filter((s) => s.username === props.policy.user)[0];
			if (!user) {
				return "<deleted student>";
			}

			return userDisplayText(user);
		}

		return "all users";
	};

	const getApp = () => {
		if (props.policy.website) {
			return props.policy.website;
		}

		if (props.policy.tag) {
			return props.signatureDb.lookup(props.policy.tag);
		}

		return "all apps";
	};

	const renderWebsiteIcon = () => {
		if (props.policy.tag) {
			const faviconUrl = props.signatureDb.favicon(props.policy.tag);

			if (faviconUrl && faviconUrl !== "") {
				return <SafeImage width={20} height={20} styleClassName="PolicyDrawer_ruleFavicon" src={faviconUrl} />;
			}
		} else if (props.policy.website) {
			return <SafeImage width={20} height={20} styleClassName="PolicyDrawer_ruleFavicon" src="/static/images/Icon_URL.svg" />;
		}

		return <SafeImage width={20} height={20} styleClassName="PolicyDrawer_ruleFavicon" src="/static/images/Icon_Folder.svg" />;
	};

	const user = getUser();
	const app = getApp();
	return (
		<>
			<div className="PolicyDrawer_itemColumn">
				<span className="PolicyDrawer_appIcon">{renderWebsiteIcon()}</span>
				<span className="PolicyDrawer_appText" title={app}>
					{app}
				</span>
			</div>
			<span className="PolicyDrawer_itemColumn PolicyDrawer_text" title={user}>
				{user}
			</span>
			<div className="PolicyDrawer_itemColumn PolicyDrawer_itemActions">
				<span>{renderStatus()}</span>
				<span onClick={props.handleModify}>
					<ChakraFAIcon icon="fa-pencil" variant="solid" className="PolicyDrawer_editRuleIcon" />
				</span>
			</div>
		</>
	);
};

export default ContentPolicy;

ContentPolicy.propTypes = {
	handleModify: PropTypes.func,
	handleChangeType: PropTypes.func,
	policy: PropTypes.object,
	signatureDb: PropTypes.object,
	users: PropTypes.array,
};
